import React from 'react';
import { Check, Wrench } from 'lucide-react';
const tomes = [{
  num: '01',
  title: 'MÉTODO SUEÑO VITAL',
  desc: 'Entiende cómo funciona el sueño de tu bebé desde su biología real. Por qué se despierta, cuánto es normal según su edad y qué puedes hacer cada noche para que tanto él como tú descanséis mejor.',
  tool: 'Log de Sueño de 7 días'
}, {
  num: '02',
  title: 'PROTOCOLO ALIVIO DIGESTIVO',
  desc: 'El llanto de gases, cólicos y reflujo tiene señales específicas que puedes aprender a identificar. Este tomo te da un protocolo claro para saber qué tipo de llanto es y qué hacer en cada caso.',
  tool: 'Semáforo del Llanto Digestivo'
}, {
  num: '03',
  title: 'SEGURIDAD INMEDIATA (SOS)',
  desc: 'Los accidentes más comunes del primer año, cómo prevenirlos y qué hacer paso a paso si ocurren. Prepararte antes de que pase cualquier cosa es la mejor forma de reducir el miedo.',
  tool: 'Ficha de Emergencia "Pega en la nevera"'
}, {
  num: '04',
  title: 'CONEXIÓN COGNITIVA',
  desc: 'Qué hitos son normales en cada etapa, qué variaciones son completamente esperables y cuáles merecen consulta con el pediatra. Deja de comparar y empieza a entender exactamente en qué momento está tu bebé.',
  tool: 'Tabla de Hitos del Primer Año'
}, {
  num: '05',
  title: 'ARMONÍA EN CASA (POSTPARTO)',
  desc: 'El postparto no es solo físico. Es emocional, relacional y logístico. Este tomo aborda la salud mental de los padres, el reparto de la carga y cómo mantener la relación de pareja cuando todo lo consume el bebé.',
  tool: 'Contrato de Coparentalidad de 4 semanas'
}, {
  num: '06',
  title: 'NUTRICIÓN Y DESTETE (BLW)',
  desc: 'Todo lo que necesitas saber sobre la alimentación complementaria: cuándo empezar, cómo hacerlo de forma segura, qué alimentos introducir primero y cómo gestionar el miedo a que se atragante.',
  tool: 'Calendario "Mis Primeros 100 Alimentos"'
}];
export const Tomes = () => <section className="bg-brand-dark py-[72px] px-5 md:px-10" data-id="element-54">
    <div className="max-w-[1040px] mx-auto" data-id="element-55">
      <div className="flex flex-col items-center mb-12" data-id="element-56">
        <h2 className="font-playfair font-bold text-[40px] text-white text-center mb-[8px]" data-id="element-57">
          El Sistema Completo
        </h2>
        <div className="w-[80px] h-[3px] bg-brand-accentPremium mb-[12px]" data-id="element-58"></div>
        <h3 className="font-inter font-bold text-[13px] text-brand-accentPremium text-center tracking-[3px] uppercase" data-id="element-59">
          6 Tomos Completos
        </h3>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-[20px]" data-id="element-60">
        {tomes.map((t, i) => <div key={i} className="bg-white/5 border border-white/10 rounded-[14px] p-[36px_32px] hover:bg-white/9 hover:border-brand-accentPremium/30 transition-all duration-200 relative overflow-hidden group" data-id="element-61">
            <div className="font-playfair font-bold text-[72px] text-brand-accentPremium/20 absolute top-[-10px] right-[20px] leading-none pointer-events-none z-0" data-id="element-62">
              {t.num}
            </div>
            <div className="bg-brand-accentPremium/16 border border-brand-accentPremium/40 text-brand-accentPremium font-inter font-bold text-[11px] tracking-[2.5px] uppercase px-[14px] py-[5px] rounded-[20px] inline-block mb-[14px] relative z-10" data-id="element-63">
              TOMO {i + 1}
            </div>
            <h4 className="font-playfair font-bold text-[24px] text-white mb-[16px] leading-[1.25] relative z-10" data-id="element-64">
              {t.title}
            </h4>
            <p className="font-inter text-[15px] text-white/65 leading-[1.68] mb-[24px] relative z-10" data-id="element-65">
              {t.desc}
            </p>
            <div className="h-[1px] bg-white/10 mb-[20px] relative z-10" data-id="element-66" />
            <div className="bg-brand-accentExtra/12 border border-brand-accentExtra/30 rounded-[8px] px-[18px] py-[14px] flex items-center gap-[10px] relative z-10" data-id="element-67">
              <Wrench className="w-[16px] h-[16px] text-brand-accentExtra shrink-0" data-id="element-68" />
              <div className="flex flex-col md:flex-row md:items-center gap-1 md:gap-2" data-id="element-69">
                <span className="font-inter font-bold text-[12px] text-brand-accentExtra tracking-[0.5px]" data-id="element-70">
                  Incluye:
                </span>
                <span className="font-inter font-semibold text-[14px] text-white" data-id="element-71">
                  {t.tool}
                </span>
              </div>
            </div>
          </div>)}
      </div>

      <div className="bg-white/4 border-t border-white/10 p-[28px_32px] mt-[32px] rounded-b-[14px] flex flex-wrap justify-center gap-[12px_24px]" data-id="element-72">
        {['Información clara y sin tecnicismos', 'Protocolos listos para aplicar hoy', 'Herramienta práctica incluida', 'Adaptado a la realidad imperfecta'].map((item, i) => <div key={i} className="flex items-center gap-2" data-id="element-73">
            <Check className="w-4 h-4 text-brand-accentExtra" data-id="element-74" />
            <span className="font-inter text-[14px] text-white/65" data-id="element-75">{item}</span>
          </div>)}
      </div>
    </div>
  </section>;
const bonuses = [{
  num: 1,
  title: 'TU GUÍA PARA NO PERDERTE',
  desc: 'El mapa completo del sistema. Rutas por edad y urgencia para saber siempre qué hacer a continuación.',
  value: '9,97€'
}, {
  num: 2,
  title: 'LO NORMAL EN CADA MES',
  desc: 'Guía de tranquilidad mes a mes. Entiende qué es normal y deja de preocuparte innecesariamente.',
  value: '7,97€'
}, {
  num: 3,
  title: 'ETAPAS DEL PRIMER AÑO',
  desc: 'Las cuatro etapas clave del primer año. Entiende los retos actuales y prepárate para lo que viene.',
  value: '7,97€'
}, {
  num: 4,
  title: 'KIT DEL DÍA A DÍA',
  desc: 'Logística real: rutinas, organización del hogar y reparto de tareas para eliminar el caos diario.',
  value: '19,00€'
}, {
  num: 5,
  title: 'MENOS ESTRÉS CON TU BEBÉ',
  desc: 'Herramientas para bajar la carga mental y gestionar el agotamiento. Porque tú también importas.',
  value: '9,97€'
}, {
  num: 6,
  title: 'RESPIRA UN POCO',
  desc: 'Técnicas de calma inmediata para momentos críticos. El apoyo que necesitas cuando sientes que no puedes más.',
  value: '9,97€'
}];
export const Bonuses = () => <section className="bg-brand-bgAlt py-[72px] px-5 md:px-10" data-id="element-76">
    <div className="max-w-[720px] mx-auto" data-id="element-77">
      <div className="flex flex-col items-center mb-[40px]" data-id="element-78">
        <h2 className="font-playfair font-bold text-[36px] text-brand-text text-center mb-[8px]" data-id="element-79">
          Bonos Incluidos
        </h2>
        <div className="w-[64px] h-[3px] bg-brand-accentPremium mb-[12px]" data-id="element-80"></div>
        <h3 className="font-inter font-semibold text-[13px] text-brand-textSec text-center tracking-[2px] uppercase" data-id="element-81">
          6 Bonos Estratégicos — Siempre Incluidos
        </h3>
      </div>

      <div className="flex flex-col gap-[10px]" data-id="element-82">
        {bonuses.map((b, i) => <div key={i} className="bg-white rounded-r-[12px] p-[16px_24px] shadow-[0_2px_10px_rgba(15,30,58,0.05)] border border-brand-borderDorado border-l-[4px] border-l-brand-accent flex flex-row items-center" data-id="element-83">
            <div className="w-[40px] h-[40px] rounded-full bg-brand-dark text-white font-inter font-bold text-[15px] flex items-center justify-center shrink-0 mr-[20px]" data-id="element-84">
              {b.num}
            </div>
            <div className="flex-grow" data-id="element-85">
              <div className="bg-brand-paleBlue border border-brand-accent/20 text-brand-accent font-inter font-bold text-[10px] tracking-[1.5px] uppercase px-[10px] py-[3px] rounded-[10px] inline-block mb-[4px]" data-id="element-86">
                BONO {b.num}
              </div>
              <h4 className="font-inter font-semibold text-[16px] text-brand-text mb-[2px]" data-id="element-87">
                {b.title}
              </h4>
              <p className="font-inter text-[14px] text-brand-textSec leading-[1.5]" data-id="element-88">
                {b.desc}
              </p>
            </div>
            <div className="flex flex-col items-end gap-[4px] shrink-0 ml-[20px]" data-id="element-89">
              <span className="font-inter text-[13px] text-brand-textStrikethrough line-through" data-id="element-90">
                {b.value}
              </span>
              <span className="bg-brand-dark text-white font-inter font-bold text-[12px] px-[14px] py-[5px] rounded-[16px]" data-id="element-91">
                GRATIS
              </span>
            </div>
          </div>)}
      </div>

      <div className="bg-brand-dark rounded-[12px] p-[24px_32px] mt-[32px] flex flex-row justify-between items-center" data-id="element-92">
        <div className="flex flex-col" data-id="element-93">
          <div className="font-inter text-[16px] text-white/60" data-id="element-94">
            Valor total bonos:
          </div>
          <div className="font-playfair text-[26px] text-white/35 line-through" data-id="element-95">
            55,82€
          </div>
        </div>
        <div className="font-inter font-bold text-[22px] text-brand-accentPremium" data-id="element-96">
          GRATIS con tu MegaPack
        </div>
      </div>

      <div className="mt-[52px] flex justify-center" data-id="element-97">
        <button onClick={() => document.getElementById('pricing-section')?.scrollIntoView({
        behavior: 'smooth'
      })} className="bg-brand-accent hover:bg-brand-accentHover text-white font-inter font-bold text-[18px] px-[56px] py-[20px] rounded-[10px] shadow-[0_8px_24px_rgba(74,114,184,0.38)] hover:shadow-[0_10px_30px_rgba(74,114,184,0.48)] transition-all duration-250 transform hover:-translate-y-[2px] w-full md:w-fit" data-id="element-98">
          → QUIERO MI MEGAPACK AHORA
        </button>
      </div>
    </div>
  </section>;
export const Pricing = () => <section id="pricing-section" className="bg-brand-bg py-[72px] px-5 md:px-10" data-id="element-99">
    <div className="max-w-[940px] mx-auto" data-id="element-100">
      <div id="pricing-section" className="flex justify-center mb-[36px] scroll-mt-20" data-id="element-101">
        <div className="bg-brand-accentPremium/12 border border-brand-accentPremium text-[#A07820] font-inter font-semibold text-[13px] px-[24px] py-[9px] rounded-[24px]" data-id="element-102">
          ⚠️ Precio especial de lanzamiento
        </div>
      </div>

      <h2 className="font-playfair font-bold text-[40px] text-brand-text text-center mb-[10px]" data-id="element-103">
        Elige Tu MegaPack
      </h2>
      <p className="font-inter text-[17px] text-brand-textSec text-center mb-[48px]" data-id="element-104">
        La inversión en tu tranquilidad como padre o madre
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-[24px] items-stretch" data-id="element-105">
        {/* MegaPack 1 */}
        <div className="bg-white border-2 border-brand-borderMedio rounded-[18px] p-[48px_44px] relative flex flex-col order-2 md:order-1 shadow-[0_4px_20px_rgba(15,30,58,0.08)]" data-id="element-106">
          <div className="font-inter font-bold text-[11px] text-brand-textSec tracking-[3px] uppercase mb-[10px]" data-id="element-107">
            MEGAPACK 1
          </div>
          <h3 className="font-playfair font-bold text-[28px] text-brand-text mb-[6px]" data-id="element-108">
            Cómo entender a tu bebé
          </h3>
          <p className="font-inter text-[15px] text-brand-textSec mb-[28px]" data-id="element-109">
            6 Tomos + 6 Bonos
          </p>

          <div className="h-[1px] bg-brand-borderSuave mb-[28px]" data-id="element-110" />

          <ul className="space-y-[12px] flex-grow mb-[32px]" data-id="element-111">
            {['Los 6 Tomos en PDF', 'Los 6 Bonos incluidos', 'Acceso de por vida'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-112">
                <Check className="w-5 h-5 text-brand-accentExtra shrink-0" data-id="element-113" />
                <span className="font-inter text-[15px] text-brand-text" data-id="element-114">
                  {item}
                </span>
              </li>)}
          </ul>

          <div className="h-[1px] bg-brand-borderSuave mb-[28px]" data-id="element-115" />

          <div data-id="element-116">
            <div className="font-inter text-[18px] text-brand-textStrikethrough line-through mb-[4px]" data-id="element-117">
              75,76€
            </div>
            <div className="font-playfair font-bold text-[60px] text-brand-text leading-[1] mb-[32px]" data-id="element-118">
              14,97€
            </div>
          </div>

          <button className="bg-brand-accent hover:bg-brand-accentHover text-white font-inter font-bold text-[16px] w-full py-[17px] rounded-[10px] shadow-[0_4px_14px_rgba(74,114,184,0.30)] transition-colors" data-id="element-119">
            QUIERO MI MEGAPACK
          </button>
        </div>

        {/* MegaPack Completo */}
        <div className="bg-brand-dark border-2 border-brand-accentPremium rounded-[18px] p-[48px_44px] relative shadow-[0_20px_56px_rgba(15,30,58,0.35)] flex flex-col order-1 md:order-2 transform md:scale-[1.04]" data-id="element-120">
          <div className="absolute -top-[18px] left-1/2 transform -translate-x-1/2 bg-brand-accentPremium text-white font-inter font-bold text-[13px] px-[28px] py-[9px] rounded-[24px] whitespace-nowrap" data-id="element-121">
            ⭐ MÁS ELEGIDO
          </div>

          <div className="font-inter font-bold text-[11px] text-white/45 tracking-[3px] uppercase mb-[10px]" data-id="element-122">
            MEGAPACK COMPLETO
          </div>
          <h3 className="font-playfair font-bold text-[28px] text-white mb-[6px]" data-id="element-123">
            Sistema Completo + Premium
          </h3>
          <p className="font-inter text-[15px] text-white/60 mb-[28px]" data-id="element-124">
            La solución completa para el primer año y más allá
          </p>

          <div className="h-[1px] bg-white/12 mb-[28px]" data-id="element-125" />

          <ul className="space-y-[12px] flex-grow mb-[32px]" data-id="element-126">
            <li className="flex items-start gap-3" data-id="element-127">
              <Check className="w-5 h-5 text-brand-accentExtra shrink-0" data-id="element-128" />
              <span className="font-inter text-[15px] text-white/80" data-id="element-129">
                Todo lo del MegaPack 1
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-130">
              <Check className="w-5 h-5 text-brand-accentExtra shrink-0 mt-0.5" data-id="element-131" />
              <div className="font-inter text-[15px] text-white/80" data-id="element-132">
                <strong data-id="element-133">DESARROLLO SIN LÍMITES (eBook Premium)</strong>
                <br data-id="element-134" />
                <span className="text-sm text-white/60" data-id="element-135">
                  Cómo despertar la inteligencia de tu bebé desde el primer día
                  (0-2 años)
                </span>
              </div>
            </li>
          </ul>

          <div className="h-[1px] bg-white/12 mb-[28px]" data-id="element-136" />

          <div data-id="element-137">
            <div className="font-inter text-[18px] text-white/28 line-through mb-[4px]" data-id="element-138">
              157,49€
            </div>
            <div className="font-playfair font-bold text-[60px] text-brand-accentPremium leading-[1] mb-[32px]" data-id="element-139">
              23,97€
            </div>
          </div>

          <button className="bg-brand-accentPremium hover:bg-[#C49840] text-white font-inter font-bold text-[17px] w-full py-[18px] rounded-[10px] shadow-[0_6px_20px_rgba(212,168,74,0.45)] hover:shadow-[0_8px_26px_rgba(212,168,74,0.55)] transition-all" data-id="element-140">
            QUIERO EL SISTEMA COMPLETO
          </button>
        </div>
      </div>

      <div className="flex flex-wrap justify-center gap-[24px] mt-[36px]" data-id="element-141">
        {['Pago 100% seguro', 'Acceso en 5 minutos', 'Garantía 7 días'].map((item, i) => <div key={i} className="flex items-center gap-2" data-id="element-142">
              <Check className="w-4 h-4 text-brand-accentExtra" data-id="element-143" />
              <span className="font-inter text-[14px] text-brand-textSec" data-id="element-144">
                {item}
              </span>
            </div>)}
      </div>
    </div>
  </section>;